import { IconType } from "react-icons";

type ReactIconProps = {
  icon: IconType;
  className?: string;
};

export const ReactIcon = ({
  icon: IconComponent,
  className,
}: ReactIconProps): JSX.Element => {
  return IconComponent({ className }) as JSX.Element;
};
